import {
  CREATEUSERPOOLCLIENT,
  CREATEUSERPOOLCLIENT_SUCCESS,
  UPDATEUSERPOOLCLIENT,
  UPDATEUSERPOOLCLIENT_SUCCESS,
  FETCHUSERPOOLCLIENTS,
  FETCHUSERPOOLCLIENTS_SUCCESS,
  DELETEUSERPOOLCLIENT,
  DELETEUSERPOOLCLIENT_SUCCESS,
} from "constants/ActionTypes";

export const fetchUserPoolClients = () => {
  return {
    type: FETCHUSERPOOLCLIENTS,
    payload: {
    }
  };
};

export const fetchUserPoolClientsSuccess = (userPoolClients) => {
  return {
    type: FETCHUSERPOOLCLIENTS_SUCCESS,
    payload: userPoolClients
  };
};

export const createUserPoolClient = (creatingUserPoolClient) => {
  console.log('creatingUserPoolClient', creatingUserPoolClient)
  return {
    type: CREATEUSERPOOLCLIENT,
    payload: creatingUserPoolClient
  };
};

export const createUserPoolClientSuccess = (createdUserPoolClient) => {

  return {
    type: CREATEUSERPOOLCLIENT_SUCCESS,
    payload: createdUserPoolClient
  };
};

export const updateUserPoolClient = (updatingUserPoolClient) => {
  console.log('updatingUserPoolClient', updatingUserPoolClient)
  return {
    type: UPDATEUSERPOOLCLIENT,
    payload: updatingUserPoolClient
  };
};

export const updateUserPoolClientSuccess = (updatedUserPoolClient) => {
  console.log('updatedUserPoolClient', updatedUserPoolClient)

  return {
    type: UPDATEUSERPOOLCLIENT_SUCCESS,
    payload: updatedUserPoolClient
  };
};

export const deleteUserPoolClient = (deletingUserPoolClient) => {

  return {
    type: DELETEUSERPOOLCLIENT,
    payload: deletingUserPoolClient
  };
};

export const deleteUserPoolClientSuccess = (deletedUserPoolClient) => {

  return {
    type: DELETEUSERPOOLCLIENT_SUCCESS,
    payload: deletedUserPoolClient
  };
};
